import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import StaffDashboard from "@/pages/StaffDashboard";
import StaffTimesheets from "@/pages/StaffTimesheets";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminStaff from "@/pages/AdminStaff";
import AdminStaffDetail from "@/pages/AdminStaffDetail";
import AdminCorrections from "@/pages/AdminCorrections";
import AdminReports from "@/pages/AdminReports";
import StaffRoster from "@/pages/StaffRoster";
import AdminRoster from "@/pages/AdminRoster";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route
                path="/"
                element={
                  <ProtectedRoute role="staff">
                    <StaffDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/timesheets"
                element={
                  <ProtectedRoute role="staff">
                    <StaffTimesheets />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/roster"
                element={
                  <ProtectedRoute role="staff">
                    <StaffRoster />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute role="admin">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/staff"
                element={
                  <ProtectedRoute role="admin">
                    <AdminStaff />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/roster"
                element={
                  <ProtectedRoute role="admin">
                    <AdminRoster />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/staff/:id"
                element={
                  <ProtectedRoute role="admin">
                    <AdminStaffDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/corrections"
                element={
                  <ProtectedRoute role="admin">
                    <AdminCorrections />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/reports"
                element={
                  <ProtectedRoute role="admin">
                    <AdminReports />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
